import { defineMessages } from 'react-intl';

export const messages: {
	buildAgentButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	activateAgentButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	publishAgentButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	buildAgentButtonLabel: {
		id: 'conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.build-agent-button-label',
		defaultMessage: 'Build agent',
		description: 'Build agent button label (displayed at the footer of the card)',
	},
	activateAgentButtonLabel: {
		id: 'conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.activate-agent-button-label',
		defaultMessage: 'Activate agent',
		description: 'Activate agent button label (displayed at the footer of the card)',
	},
	publishAgentButtonLabel: {
		id: 'conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.publish-agent-button-label',
		defaultMessage: 'Publish agent',
		description: 'Publish agent button label (displayed at the footer of the card)',
	},
});
